import type { BannerMode } from "./gamePageBannerImages";
import GAME_PAGE_BANNER_IMAGES from "./gamePageBannerImages";

type Args = {
  mode: BannerMode;
  site?: Site;
};

type GamePageBanners = {
  bg: string;
  bgMobile: string;
  fg: string;
  fgMobile: string;
};

// Both the desktop and mobile crops of the background and foreground are
// always returned — the caller picks between them client-side (via a
// viewport media query) instead of trusting server-side user-agent sniffing.
const getGamePageBanners = ({
  mode,
  site = "bitcasino",
}: Args): GamePageBanners => {
  const images = GAME_PAGE_BANNER_IMAGES[mode];
  // Fall back to bitcasino only when the site has no entry at all — a site
  // that has an entry but left `fg` empty means "no foreground yet", not
  // "borrow bitcasino's".
  const desktopArtwork = images[site]?.desktop ?? images.bitcasino.desktop;
  const mobileArtwork = images[site]?.mobile ?? images.bitcasino.mobile;

  return {
    bg: desktopArtwork.bg,
    bgMobile: mobileArtwork.bg,
    fg: desktopArtwork.fg ?? "",
    fgMobile: mobileArtwork.fg ?? "",
  };
};

export default getGamePageBanners;
